module.exports = __webpack_public_path__ + "static/media/background-playlist-image-3.514f9125.svg";